import { useMemo } from 'react';
import { Badge, TableColumn } from '@silverfort/sf-components';
import { Resource } from '../../../types/Resource';
import { InvestigationCell } from '../../InvestigationCell';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { MfaEnforcementStatusColors } from '../../../common/mfaEnforcementStatusColors';
import { useActiveDirectoryAccessContext } from '../../../context';
import { DateFormat, formatDate } from '../../../../../utils/dates';

export const useColumns = (openDrawer: (resource: Resource) => void) => {
    const { hasPolicyEnabled } = useActiveDirectoryAccessContext();

    return useMemo<Array<TableColumn<Resource>>>(() => {
        const columns: Array<TableColumn<Resource>> = [
            {
                columnKey: 'name',
                title: 'Resource',
                render: (resource: Resource) => {
                    if (resource.type === 'hostname') {
                        return (
                            <InvestigationCell
                                adType={AD_ENTITY_TYPES.SERVER}
                                id={resource.resource_id}
                                name={resource.name}
                                onClick={() => openDrawer(resource)}
                            />
                        );
                    }

                    return (
                        <div className="cursor-pointer" onClick={() => openDrawer(resource)}>
                            {resource.name}
                        </div>
                    );
                }
            },
            { columnKey: 'type', title: 'Type', render: ({ type }) => (type === 'ip' ? 'IP' : 'Hostname') },
            { columnKey: 'active_user_count', title: 'Active users' },
            {
                columnKey: 'last_access',
                title: 'Last login',
                render: ({ last_access }) =>
                    last_access ? formatDate(last_access, DateFormat.SHORT_DATE_MD, true) : 'N/A'
            }
        ];

        if (hasPolicyEnabled) {
            columns.push({
                columnKey: 'mfa_enforcement_status',
                disableSort: true,
                render: ({ mfa_enforcement_status }) => {
                    return (
                        <div className="flex">
                            <Badge
                                className="shrink-0"
                                color={MfaEnforcementStatusColors[mfa_enforcement_status]}
                                text={mfa_enforcement_status}
                            />
                        </div>
                    );
                },
                title: 'MFA enforced'
            });
        }

        return columns;
    }, [hasPolicyEnabled, openDrawer]);
};
